module.exports = __webpack_public_path__ + "static/media/student-login-logo.1ce334b2.png";